import { Outlet } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";
import CabinetLayout from "./cabinetLayout";
import EmailNotConfirmed from "./emailNotConfirmed";
import LoadingIndicator from "../common/loadingIndicator";
import { useTranslation } from "react-i18next";

function Cabinet() {
  const {isEmailConfirmed, authorizedEmail} = useAuthStore();
  const { t } = useTranslation();  

  return (
    <>
      <CabinetLayout>
        {isEmailConfirmed && <Outlet />}
        {!isEmailConfirmed && authorizedEmail !== null && authorizedEmail!.length > 1 && <EmailNotConfirmed />} 
        {!isEmailConfirmed && authorizedEmail !== null && authorizedEmail!.length === 0 && <LoadingIndicator text={t("loading")}/>}
      </CabinetLayout>
    </>
  );
}

export default Cabinet;
